<div class="form-group distribution-percent inline" [class.required]="isRequired" [formGroup]="parentForm">
  <mat-form-field [floatLabel]="'always'" appearance="fill" [class.readonly]="true" class="distribution-input">
    <mat-label>{{ title }}</mat-label>
    <input
      matInput
      mask="separator.2"
      decimalMarker=","
      [class.is-invalid]="control.invalid && control.touched"
      type="text"
      class="form-control"
      [formControlName]="controlName"
    />
  </mat-form-field>

  <span class="percentInclus"> % </span>
</div>

<!-- [value]="parentForm.get(controlName).value | roundTo2Decimal" -->